import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

const CustomDrawer = ({
  isOpen,
  onClose,
  children,
  size,
  removePadding = true,
  theme,
  roundedTop = false,
}) => {
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      direction="bottom"
      className={`flex ${removePadding ? "" : "p-10"} flex-col ${
        roundedTop && "rounded-t-3xl"
      } overflow-hidden`} // Added rounded-t-3xl and overflow-hidden
      size={size ? size : "100%"}
      styles={{
        backgroundColor: theme?.bgColor || "black",
        // Ensure drawer doesn't cover screen edges
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "100vw", // Prevents horizontal overflow
      }}
    >
      <div
        className={`h-full mx-auto w-full max-w-lg sm:max-w-lg md:max-w-lg lg:max-w-md ${
          theme ? theme.backgroundColor : "bg-black"
        }`}
      >
        {children}
      </div>
    </Drawer>
  );
};

export default CustomDrawer;
